const accuracyConfig = {
    image: {
        listLayout: 'ImageListLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: "getImageList",
        insertFunc: "insertImageList",

        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        categoryApiParamSet: {},
        keyName: 'i_idx',
        pageRow: 10,
        paginationType: 'pagination',
        isGetFirst: false,

    },
    price: {
        listLayout: 'PriceListLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: "getPriceList",
        insertFunc: "insertPriceList",
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        categoryApiParamSet: {},
        keyName: 'i_idx',
        pageRow: 10,
        paginationType: 'pagination',
        isGetFirst: false,

    },
}

export default {
    methods: {
        returnAccuracyConfig(type) {
            return accuracyConfig[type];
        },
    },
    filterConfig: {
        'call_page': { // 답변 상태
            type: 'match',
            classname: 'listCount',
        },
    },
}